import React, { useState, useContext, useEffect, useRef } from "react";
import api from "../../api/axiosConfig";
import { TfiFilter } from "react-icons/tfi";
import { useParams } from "react-router-dom";
import { ProjectContext } from "../../App";
import DateRangePickerComp from "./DateRangePicker";
import { useAuth } from "../Authentication/AuthContext";
import { FaCheckCircle } from "react-icons/fa";
import "./TimeSheetTable.css";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { format } from "date-fns";

const FilterTimeSheet = ({
  refresh: refreshTrigger = () => {},
  onTimesheetUpdated,
}) => {
  const [filters, setFilters] = useState({});
  const [projects, setProjects] = useState([]);
  const [phases, setPhases] = useState(() => {
    const storedPhases = localStorage.getItem("phases"); // Retrieve from localStorage
    return storedPhases ? JSON.parse(storedPhases) : []; // Parse if exists, else default to empty array
  });
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [taskList, setTaskList] = useState(() => {
    const storedTasks = localStorage.getItem("tasks"); // Retrieve tasks from localStorage
    return storedTasks ? JSON.parse(storedTasks) : []; // Parse if exists, else default to empty array
  });
  const [filteredTasks, setFilteredTasks] = useState([]);
  const taskRef = useRef(null);
  const [searchTask, setSearchTask] = useState("");
  const [selectedTaskName, setSelectedTaskName] = useState("");
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [showTaskDropdown, setShowTaskDropdown] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const { dialBoxopen, isNavBarOpen } = useContext(ProjectContext);
  const { userDetails } = useAuth();
  const userID = userDetails.id;
  const [users, setUsers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [user, setUser] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedAdmin = localStorage.getItem("selectedAdmin");
    return savedAdmin ? JSON.parse(savedAdmin) : [];
  });
  const [task, setTask] = useState(""); // New log title field
  const [logUserCondition, setLogUserCondition] = useState(
    () => localStorage.getItem("logUserCondition") || "is"
  );
  const [ProjectCondition, setProjectCondition] = useState(
    () => localStorage.getItem("projectCondition") || "is"
  );
  const [phaseCondition, setPhaseCondition] = useState(
    () => localStorage.getItem("phaseCondition") || "is"
  );
  const [taskCondition, setTaskCondition] = useState(
    () => localStorage.getItem("taskCondition") || "is"
  );
  const [billableCondition, setBillableCondition] = useState(
    () => localStorage.getItem("billableCondition") || "is"
  );
  const [categoryCondition, setCategoryCondition] = useState(
    () => localStorage.getItem("categoryCondition") || "is"
  );
  const [approvalStatusCondition, setApprovalStatusCondition] = useState(
    () => localStorage.getItem("approvalStatusCondition") || "is"
  );
  const [approvalByCondition, setApprovalByCondition] = useState(
    () => localStorage.getItem("approvalByCondition") || "is"
  );
  const [fromDate, setFromDate] = useState(null); // Updated state for fromDate
  const [toDate, setToDate] = useState(null); // Updated state for toDate
  const [billable, setBillable] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedBillable = localStorage.getItem("billable");
    return savedBillable ? JSON.parse(savedBillable) : [];
  });
  const [categoryValue, setCategoryValue] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedCategory = localStorage.getItem("categoryValue");
    return savedCategory ? JSON.parse(savedCategory) : [];
  });
  const [approvalstatus, setApprovalStatus] = useState(() => {
    // Retrieve from localStorage or default to an empty array
    const savedApprovalStatus = localStorage.getItem("approvalstatus");
    return savedApprovalStatus ? JSON.parse(savedApprovalStatus) : [];
  });
  const { projectId } = useParams();
  const [loading, setLoading] = useState(true);
  const [logUsersOpen, setLogUserOpen] = useState(true);
  const [projectsOpen, setProjectsOpen] = useState(true);
  const [phaseOpen, setPhaseOpen] = useState(true);
  const [selectedPhase, setSelectedPhase] = useState(() => {
    const storedPhase = localStorage.getItem("selectedPhase");
    return storedPhase ? JSON.parse(storedPhase) : ""; // Use an empty string instead of [""].
  });
  const [taskOpen, setTaskOpen] = useState(true);
  const [isBillable, setIsBillable] = useState(true);
  const [category, setCategory] = useState(true);
  const [approvalStatusOpen, setApprovalStatusOpen] = useState(true);
  const [approvedbyOpen, setApprovedbyOpen] = useState(true);
  const [range, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const onClickFilterTimesheet = () => {
    setOpenDialog(true);
    document.body.classList.add("no-scroll");
  };

  const onClosePopUp = () => {
    setOpenDialog(false);
    document.body.classList.remove("no-scroll");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint =
          userDetails.role_name === "Administrator" ||
          userDetails.role_name === "Super Admin"
            ? `/api/projectlistdata`
            : `/api/projectlistdata/${userID}`;

        const [usersRes, userAdmin, projectRes] = await Promise.all([
          api.get(`/api/users`),
          api.get(`/api/users/admin`),
          api.get(endpoint),
        ]);
        if (Array.isArray(userAdmin.data)) {
          setAdmins(userAdmin.data);
        } else {
          console.error("Unexpected data structure:", userAdmin.data);
        }
        const activeUsers = usersRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        const activeProjects = projectRes.data.filter(
          (project) => project.activestatus === 1
        );
        setProjects(activeProjects);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Load selected users from local storage when the component mounts
    const storedUsers = localStorage.getItem("selectedUsers");
    const storedProjects = localStorage.getItem("selectedProjects");
    const storedTask = localStorage.getItem("selectedTask");
    if (storedUsers) {
      setSelectedUsers(JSON.parse(storedUsers)); // Parse and set users
    }
    if (storedProjects) {
      setSelectedProjects(JSON.parse(storedProjects));
    }
    if (storedTask) {
      setSelectedTasks(JSON.parse(storedTask));
    }
  }, []);

  const fetchPhaseData = async () => {
    const controller = new AbortController();
    try {
      const phasesRes = await api.get(
        `/api/project/${selectedProject}/phasesplannedhours`,
        { signal: controller.signal }
      );
      const taskRes = await api.get(`/api/projecttasks/${selectedProject}`, {
        signal: controller.signal,
      });

      const phasesData = phasesRes.data?.phases || [];
      const taskData = taskRes.data || [];

      // Store in localStorage
      localStorage.setItem("phases", JSON.stringify(phasesData));
      localStorage.setItem("tasks", JSON.stringify(taskData));

      setPhases(phasesData);
      setTaskList(taskData);
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error fetching phase data:", error);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort(); // Cleanup function
  };

  useEffect(() => {
    if (selectedProject && typeof selectedProject === "number") {
      fetchPhaseData();
    }
  }, [selectedProject]);

  useEffect(() => {
    if (selectedProject) {
      fetchPhaseData();
    }
  }, [selectedProject]);

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedProjectName("");

    const filtered = projects.filter((project) => {
      const name = project.name || ""; // Fallback to an empty string
      const projectno = project.projectno || ""; // Fallback to an empty string
      const displayName = project.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        projectno.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredProjects(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };

  const handleSearchTask = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTask(e.target.value);
    setSelectedTaskName("");

    const filtered = taskList.filter((task) => {
      const name = task.name || ""; // Fallback to an empty string

      return name.toLowerCase().includes(searchValue);
    });

    setFilteredTasks(filtered);
    setShowTaskDropdown(true); // Show the dropdown when the user types
  };

  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredProjects(projects); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };

  const handleFocusTask = () => {
    setSearchTask(""); // Reset the search term to show all projects
    setFilteredTasks(taskList); // Show all Tasks when focusing on the input
    setShowTaskDropdown(true); // Show the dropdown
  };
  const handleDateRangeChange = (range) => {
    // Extracting startDate and endDate from the range, ensuring they are valid dates
    const startDate = new Date(range.startDate); // Convert to Date object
    const endDate = new Date(range.endDate); // Convert to Date object

    // Ensure that the dates are valid before proceeding
    if (!isNaN(startDate) && !isNaN(endDate)) {
      // Set the state with valid Date objects
      setFromDate(startDate);
      setToDate(endDate);
      setDateRange(startDate, endDate);

      // Automatically apply filters if both dates are selected
      handleApplyFilters(startDate, endDate);
    } else {
    }
  };

  const handleApplyFilters = (startDate, endDate) => {
    if (user)
      filters.user = { value: selectedUsers, condition: logUserCondition };
    if (selectedTasks)
      filters.selectedTasks = {
        value: selectedTasks,
        condition: taskCondition,
      };
    if (selectedProjects)
      filters.selectedProjects = {
        value: selectedProjects,
        condition: ProjectCondition,
      };
    if (selectedPhase)
      filters.selectedPhase = {
        value: selectedPhase,
        condition: phaseCondition,
      };
    // Use the passed in Date objects
    if (startDate && endDate) {
      const startDateAdjusted = new Date(startDate);

      startDateAdjusted.setHours(0, 0, 0, 0); // Start of the day

      const endDateAdjusted = new Date(endDate);
      endDateAdjusted.setHours(23, 59, 59, 999); // End of the day

      // Custom function to format date as YYYY-MM-DD without converting to UTC
      const formatDateToLocal = (date) => {
        return `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      };

      filters.dateFilterType = "range";
      filters.fromDate = formatDateToLocal(startDateAdjusted); // Use adjusted start date without timezone issues
      filters.toDate = formatDateToLocal(endDateAdjusted); // Use adjusted end date

      // Log filters after setting date range
    }

    if (billable)
      filters.billable = { value: billable, condition: billableCondition };
    if (categoryValue)
      filters.categoryValue = {
        value: categoryValue,
        condition: categoryCondition,
      };
    if (approvalstatus)
      filters.approvalstatus = {
        value: approvalstatus,
        condition: approvalStatusCondition,
      };
    if (selectedAdmin)
      filters.selectedAdmin = {
        value: selectedAdmin,
        condition: approvalByCondition,
      };
    if (typeof refreshTrigger === "function") {
      refreshTrigger(filters);
    } else {
      console.error("refreshTrigger is not a function");
    }
    onClosePopUp();
  };
  const toggleUserSelection = (user_details) => {
    let updatedUsers;

    if (selectedUsers.includes(user_details.name)) {
      // Remove user if already selected
      updatedUsers = selectedUsers.filter((user) => user !== user_details.name);
    } else {
      // Add user if not selected
      updatedUsers = [...selectedUsers, user_details.name];
    }

    setSelectedUsers(updatedUsers);

    // Save updated selection to local storage
    localStorage.setItem("selectedUsers", JSON.stringify(updatedUsers));
  };
  const toggleProjectSelection = (p) => {
    fetchPhaseData();
    setSearchTerm("");
    setShowDropdown(false);
    setSelectedProject(p.id);
    let updatedProject;
    // Check if the user is already selected
    if (selectedProjects.includes(p.name)) {
      // Remove user from the selectedUsers array
      updatedProject = selectedProjects.filter(
        (selected) => selected !== p.name
      );
    } else {
      // Add user to the selectedUsers array
      updatedProject = [...selectedProjects, p.name];
    }
    localStorage.setItem("selectedProjects", JSON.stringify(updatedProject));
    setSelectedProjects(updatedProject);
  };

  const toggleTaskSelection = (t) => {
    setSearchTask("");
    setShowTaskDropdown(false);
    let updatedTask;
    // Check if the user is already selected
    if (selectedTasks.includes(t.name)) {
      // Remove user from the selectedUsers array
      updatedTask = selectedTasks.filter((selected) => selected !== t.name);
    } else {
      // Add user to the selectedUsers array
      updatedTask = [...selectedTasks, t.name];
    }
    setSelectedTasks(updatedTask);

    localStorage.setItem("selectedTask", JSON.stringify(updatedTask));
  };

  const toggleAdminSelection = (adminId) => {
    // Check if the admin ID is already selected
    if (selectedAdmin.includes(adminId)) {
      // Remove admin ID from selectedAdmin
      setSelectedAdmin(selectedAdmin.filter((id) => id !== adminId));
    } else {
      // Add admin ID to selectedAdmin
      setSelectedAdmin([...selectedAdmin, adminId]);
    }
  };
  useEffect(() => {
    // Save to localStorage whenever billable changes
    localStorage.setItem("selectedAdmin", JSON.stringify(selectedAdmin));
  }, [selectedAdmin]);
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // Add value to the billable array if checked
      setBillable((prev) => [...prev, value]);
    } else {
      // Remove value from the billable array if unchecked
      setBillable((prev) => prev.filter((item) => item !== value));
    }
  };
  const handleCategoryChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // Add value to the billable array if checked
      setCategoryValue((prev) => [...prev, value]);
    } else {
      // Remove value from the billable array if unchecked
      setCategoryValue((prev) => prev.filter((item) => item !== value));
    }
  };
  useEffect(() => {
    // Save to localStorage whenever billable changes
    localStorage.setItem("billable", JSON.stringify(billable));
  }, [billable]);
  useEffect(() => {
    // Save to localStorage whenever billable changes
    localStorage.setItem("categoryValue", JSON.stringify(categoryValue));
  }, [categoryValue]);
  const handleCheckboxApprovalStatusChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // Add value to the billable array if checked
      setApprovalStatus((prev) => [...prev, value]);
    } else {
      // Remove value from the billable array if unchecked
      setApprovalStatus((prev) => prev.filter((item) => item !== value));
    }
  };
  useEffect(() => {
    // Save to localStorage whenever approvalstatus changes
    localStorage.setItem("approvalstatus", JSON.stringify(approvalstatus));
  }, [approvalstatus]);

  return (
    <div>
      <div>
        <div
          className="date-range span-input"
          value={
            range[0].startDate && range[0].endDate
              ? `${format(range[0].startDate, "MM-dd-yyyy")} to ${format(
                  range[0].endDate,
                  "MM-dd-yyyy"
                )}`
              : "Select a date range"
          }
        >
          <span>
            <DateRangePickerComp onDateRangeChange={handleDateRangeChange} />
          </span>
        </div>
        <button onClick={onClickFilterTimesheet} style={{ border: "none" }}>
          <TfiFilter
            title="Filter"
            className={
              isNavBarOpen ? "time-log-filter-btn" : "time-log-filter-btn-close"
            }
            style={{ zIndex: "9", left: "16px" }}
          />
        </button>
      </div>

      {openDialog && (
        <div className={`filter-dial  ${dialBoxopen ? "open" : "close"}`}>
          <div className="filter-overview-con">
            <div className="new-time-log">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "10px",
                  marginTop: "5px",
                }}
              >
                Filter Options
              </h3>
            </div>
            <div className="overview-filter-scrollable-t-content">
              {(userDetails.role_name === "Administrator" ||
                userDetails.role_name === "Project_Manager" ||
                userDetails.role_name === "Super Admin") && (
                <div
                  className={
                    logUsersOpen ? "accordion-u-header" : "accordion-header"
                  }
                  style={{ marginBottom: "-1px", borderTop: "none" }}
                >
                  <h3
                    className="accordion-label"
                    onClick={() => setLogUserOpen((prev) => !prev)}
                  >
                    Log Users
                    {selectedUsers.length > 0 && (
                      <span className="users-count">
                        {selectedUsers.length}
                      </span>
                    )}
                  </h3>

                  {!logUsersOpen && (
                    <select
                      className="is-not"
                      value={logUserCondition}
                      onChange={(e) => {
                        setLogUserCondition(e.target.value);
                        localStorage.setItem(
                          "logUserCondition",
                          e.target.value
                        );
                      }}
                    >
                      <option value="is">Is</option>
                      <option value="not">Is Not</option>
                    </select>
                  )}
                  <span
                    onClick={() => setLogUserOpen((prev) => !prev)}
                    className="span-element"
                  >
                    {logUsersOpen ? (
                      <FaChevronRight className="arrow-icon" />
                    ) : (
                      <FaChevronDown className="arrow-d-icon" />
                    )}
                  </span>
                </div>
              )}
              {(userDetails.role_name === "Administrator" ||
                userDetails.role_name === "Project_Manager" ||
                userDetails.role_name === "Super Admin") && (
                <div
                  className={logUsersOpen ? "hide" : "filter-name-field"}
                  style={{
                    height:
                      userDetails.role_name === "Administrator" ||
                      userDetails.role_name === "Super Admin"
                        ? "133px"
                        : "auto",
                  }}
                >
                  {userDetails.role_name === "Administrator" ||
                  userDetails.role_name === "Project_Manager" ||
                  userDetails.role_name === "Super Admin" ? (
                    <ul className="user-ul">
                      {users
                        .sort((a, b) => a.name.localeCompare(b.name)) // Sort users alphabetically by name
                        .map((user_details) => (
                          <li
                            key={user_details.id}
                            onClick={() => toggleUserSelection(user_details)} // Pass correct user object
                            className={"user-name-list"}
                          >
                            <span className="initial">
                              {selectedUsers.includes(user_details.name) ? (
                                <FaCheckCircle
                                  style={{ backgroundColor: "transparent" }}
                                />
                              ) : (
                                user_details.name
                                  .charAt(user_details.name.length - 1)
                                  .toUpperCase() +
                                user_details.name.charAt(0).toUpperCase()
                              )}
                            </span>{" "}
                            <span
                              style={{
                                backgroundColor: "transparent",
                                marginTop: "2px",
                              }}
                            >
                              {user_details.name}
                            </span>
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <ul className="users-ul">
                      <li
                        key={userDetails.id}
                        onClick={() => toggleUserSelection(userDetails)} // Pass correct user object
                        className={"user-name-list"}
                      >
                        <span className="initial">
                          {selectedUsers.includes(userDetails.name) ? (
                            <FaCheckCircle
                              style={{ backgroundColor: "transparent" }}
                            />
                          ) : (
                            userDetails.name
                              .charAt(userDetails.name.length - 1)
                              .toUpperCase() +
                            userDetails.name.charAt(0).toUpperCase()
                          )}
                        </span>{" "}
                        <span
                          style={{
                            backgroundColor: "transparent",
                            marginTop: "2px",
                          }}
                        >
                          {userDetails.name}
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
              )}
              <div
                className={
                  projectsOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setProjectsOpen((prev) => !prev)}
                >
                  Projects{" "}
                  {selectedProjects.length > 0 && (
                    <span className="users-count">
                      {selectedProjects.length}
                    </span>
                  )}
                </h3>
                {!projectsOpen && (
                  <select
                    className="is-not"
                    value={ProjectCondition}
                    onChange={(e) => {
                      setProjectCondition(e.target.value);
                      localStorage.setItem("projectCondition", e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setProjectsOpen((prev) => !prev)}
                  className="span-element"
                >
                  {projectsOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className={projectsOpen ? "hide" : "filter-name-field"}>
                <div className="filter-project-search">
                  <input
                    ref={dropdownRef}
                    className="filter-p-input"
                    placeholder="Search Projects"
                    value={searchTerm || selectedProjectName}
                    onChange={handleSearchChange}
                    onFocus={handleFocus}
                    onMouseDown={() => handleClickOutside}
                  />
                  {showDropdown &&
                    (showDropdown && filteredProjects?.length > 0 ? (
                      <ul
                        style={{ zIndex: "50" }}
                        ref={dropdownRef}
                        className="project-display-box-overview"
                      >
                        {filteredProjects
                          .sort((a, b) => {
                            const isSelectedA = selectedProjects.includes(
                              a.name
                            )
                              ? -1
                              : 1;
                            const isSelectedB = selectedProjects.includes(
                              b.name
                            )
                              ? -1
                              : 1;
                            return isSelectedA - isSelectedB;
                          })
                          .map((project) => (
                            <li
                              key={project.id}
                              value={project.id}
                              onClick={() => toggleProjectSelection(project)}
                              onMouseDown={() => handleClickOutside}
                              className="project-dropdown-item"
                              style={{
                                color: selectedProjects.includes(project.name)
                                  ? "#6200ee"
                                  : "black",
                              }}
                            >
                              {project.projectno}-{project.name}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>No Projects available</p>
                    ))}
                </div>
              </div>
              {selectedProjects.length > 0 && (
                <>
                  <div
                    className={
                      !phaseOpen ? "accordion-u-header" : "accordion-header"
                    }
                    style={{ marginBottom: "-1px" }}
                  >
                    <h3
                      className="accordion-label"
                      onClick={() => setPhaseOpen((prev) => !prev)}
                    >
                      Phase
                      {selectedPhase.length > 0 && (
                        <span className="users-count">
                          {selectedPhase.length > 0 ? 1 : 0}
                        </span>
                      )}
                    </h3>
                    {phaseOpen && (
                      <select
                        className="is-not"
                        value={phaseCondition}
                        onChange={(e) => {
                          setPhaseCondition(e.target.value);
                          localStorage.setItem(
                            "phaseCondition",
                            e.target.value
                          );
                        }}
                      >
                        <option value="is">Is</option>
                        <option value="not">Is Not</option>
                      </select>
                    )}
                    <span
                      onClick={() => setPhaseOpen((prev) => !prev)}
                      className="span-element"
                    >
                      {!phaseOpen ? (
                        <FaChevronRight className="arrow-icon" />
                      ) : (
                        <FaChevronDown className="arrow-d-icon" />
                      )}
                    </span>
                  </div>
                  {phaseOpen && (
                    <div>
                      <select
                        className="overview-phase-dd"
                        value={selectedPhase}
                        onChange={(e) => {
                          const phaseValue = e.target.value;
                          setSelectedPhase(phaseValue);
                          localStorage.setItem(
                            "selectedPhase",
                            JSON.stringify(phaseValue)
                          ); // Store as a string
                        }}
                      >
                        <option disabled value="">
                          Select Phase
                        </option>
                        {phases.map((phase) => (
                          <option key={phase.phase_id} value={phase.phase_id}>
                            {phase.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </>
              )}
              {selectedProjects.length > 0 && (
                <>
                  <div
                    className={
                      taskOpen ? "accordion-u-header" : "accordion-header"
                    }
                    style={{ marginBottom: !taskOpen ? "0px" : "-23px" }}
                  >
                    <h3
                      className="accordion-label"
                      onClick={() => setTaskOpen((prev) => !prev)}
                    >
                      Task
                      {selectedTasks.length > 0 && (
                        <span className="users-count">
                          {selectedTasks.length}
                        </span>
                      )}
                    </h3>
                    {!taskOpen && (
                      <select
                        className="is-not"
                        value={taskCondition}
                        onChange={(e) => {
                          setTaskCondition(e.target.value);
                          localStorage.setItem("taskCondition", e.target.value);
                        }}
                      >
                        <option value="is">Is</option>
                        <option value="not">Is Not</option>
                      </select>
                    )}

                    <span
                      onClick={() => setTaskOpen((prev) => !prev)}
                      className="span-element"
                    >
                      {taskOpen ? (
                        <FaChevronRight className="arrow-icon" />
                      ) : (
                        <FaChevronDown className="arrow-d-icon" />
                      )}
                    </span>
                  </div>
                  <div className="filter-field">
                    {!taskOpen && (
                      <div className="filter-project-search">
                        <input
                          ref={taskRef}
                          className="filter-p-input"
                          placeholder="Search Task"
                          value={searchTask || selectedTaskName}
                          onChange={handleSearchTask}
                          onFocus={handleFocusTask}
                          onMouseDown={() => handleClickOutside}
                        />
                        {showTaskDropdown &&
                          (showTaskDropdown && filteredTasks?.length > 0 ? (
                            <ul
                              style={{ zIndex: "50" }}
                              ref={dropdownRef}
                              className="project-display-box-overview"
                            >
                              {filteredTasks
                                .sort((a, b) => {
                                  const isSelectedA = selectedTasks.includes(
                                    a.name
                                  )
                                    ? -1
                                    : 1;
                                  const isSelectedB = selectedTasks.includes(
                                    b.name
                                  )
                                    ? -1
                                    : 1;
                                  return isSelectedA - isSelectedB;
                                })
                                .map((task) => (
                                  <li
                                    key={task.id}
                                    value={task.id}
                                    onClick={() => toggleTaskSelection(task)}
                                    onMouseDown={() => handleClickOutside}
                                    className="project-dropdown-item"
                                    style={{
                                      color: selectedTasks.includes(task.name)
                                        ? "#6200ee"
                                        : "black",
                                    }}
                                  >
                                    {task.name}
                                  </li>
                                ))}
                            </ul>
                          ) : (
                            <p>No Task available</p>
                          ))}
                      </div>
                    )}
                  </div>
                </>
              )}
              <div
                className={
                  isBillable ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: !isBillable ? "0px" : "-24px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setIsBillable((prev) => !prev)}
                >
                  Billable
                  {billable.length > 0 && (
                    <span className="users-count">{billable.length}</span>
                  )}
                </h3>
                {!isBillable && (
                  <select
                    className="is-not"
                    value={billableCondition}
                    onChange={(e) => {
                      setBillableCondition(e.target.value);
                      localStorage.setItem("billableCondition", e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}
                <span
                  onClick={() => setIsBillable((prev) => !prev)}
                  className="span-element"
                >
                  {isBillable ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className="filter-field">
                <div
                  className={isBillable ? "hide" : "filter-billing-checkbox"}
                >
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="1"
                      checked={billable.includes("1")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCheckboxChange(e)}
                    />
                    Billable
                  </label>

                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="0"
                      checked={billable.includes("0")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCheckboxChange(e)}
                    />
                    Non-Billable
                  </label>
                </div>
              </div>
              <div
                className={category ? "accordion-u-header" : "accordion-header"}
                style={{ marginBottom: !category ? "0px" : "-24px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setCategory((prev) => !prev)}
                >
                  Category
                  {categoryValue.length > 0 && (
                    <span className="users-count">{categoryValue.length}</span>
                  )}
                </h3>
                {!category && (
                  <select
                    className="is-not"
                    value={categoryCondition}
                    onChange={(e) => {
                      setCategoryCondition(e.target.value);
                      localStorage.setItem("categoryCondition", e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}
                <span
                  onClick={() => setCategory((prev) => !prev)}
                  className="span-element"
                >
                  {category ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className="filter-field">
                <div className={category ? "hide" : "filter-billing-checkbox"}>
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="General"
                      checked={categoryValue.includes("General")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCategoryChange(e)}
                    />
                    General
                  </label>

                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="Variation"
                      checked={categoryValue.includes("Variation")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCategoryChange(e)}
                    />
                    Variation
                  </label>
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="Issue"
                      checked={categoryValue.includes("Issue")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCategoryChange(e)}
                    />
                    Issue
                  </label>
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="Non Productive"
                      checked={categoryValue.includes("Non Productive")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCategoryChange(e)}
                    />
                    Non Productive
                  </label>
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      value="Estimate"
                      checked={categoryValue.includes("Estimate")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCategoryChange(e)}
                    />
                    Estimate
                  </label>
                </div>
              </div>
              <div
                className={
                  approvalStatusOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{
                  textWrap: "nowrap",
                  marginBottom: approvalStatusOpen ? "-36px" : "",
                }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setApprovalStatusOpen((prev) => !prev)}
                >
                  Approval Status{" "}
                  {approvalstatus.length > 0 && (
                    <span className="users-count">{approvalstatus.length}</span>
                  )}
                </h3>
                {!approvalStatusOpen && (
                  <select
                    className="is-not"
                    value={approvalStatusCondition}
                    onChange={(e) => {
                      setApprovalStatusCondition(e.target.value);
                      localStorage.setItem(
                        "approvalStatusCondition",
                        e.target.value
                      );
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setApprovalStatusOpen((prev) => !prev)}
                  className="span-element"
                >
                  {approvalStatusOpen ? (
                    <FaChevronRight
                      className="arrow-icon"
                      style={{ marginLeft: approvalStatusOpen ? "188px" : "" }}
                    />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className={approvalStatusOpen ? "hide" : "filter-field"}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "18px",
                  }}
                >
                  <label>
                    <input
                      type="checkbox"
                      value="Pending"
                      checked={approvalstatus.includes("Pending")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCheckboxApprovalStatusChange(e)}
                    />
                    Pending
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      value="Approved"
                      checked={approvalstatus.includes("Approved")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCheckboxApprovalStatusChange(e)}
                    />
                    Approved
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      value="Rejected"
                      checked={approvalstatus.includes("Rejected")}
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCheckboxApprovalStatusChange(e)}
                    />
                    Rejected
                  </label>
                </div>
              </div>
              <div
                className={
                  approvedbyOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginTop: approvalStatusOpen ? "35px" : "0px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setApprovedbyOpen((prev) => !prev)}
                >
                  Approved by{" "}
                  {selectedAdmin.length > 0 && (
                    <span className="users-count">{selectedAdmin.length}</span>
                  )}
                </h3>
                {!approvedbyOpen && (
                  <select
                    className="is-not"
                    value={approvalByCondition}
                    onChange={(e) => {
                      setApprovalByCondition(e.target.value);
                      localStorage.setItem(
                        "approvalByCondition",
                        e.target.value
                      );
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setApprovedbyOpen((prev) => !prev)}
                  className="span-element"
                >
                  {approvedbyOpen ? (
                    <FaChevronRight
                      className="arrow-icon"
                      style={{ marginLeft: "210px" }}
                    />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              <div className={approvedbyOpen ? "hide" : "filter-name-field "}>
                <ul className="user-ul">
                  {Array.isArray(admins) &&
                    admins
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((user_details) => (
                        <li
                          key={user_details.id}
                          onClick={() => toggleAdminSelection(user_details.id)} // Use user ID for selection
                          className={"user-name-list"}
                        >
                          <span className="initial">
                            {selectedAdmin.includes(user_details.id) ? ( // Adjust the class based on selection
                              <FaCheckCircle
                                style={{ backgroundColor: "transparent" }}
                              />
                            ) : (
                              user_details.name
                                .charAt(user_details.name.length - 1)
                                .toUpperCase() +
                              user_details.name.charAt(0).toUpperCase()
                            )}
                          </span>{" "}
                          <span
                            style={{
                              backgroundColor: "transparent",
                              marginTop: "2px",
                            }}
                          >
                            {user_details.name}
                          </span>
                        </li>
                      ))}
                </ul>
              </div>
            </div>

            <div className="overview-filter-btn-container-add-timesheet">
              <button
                className="add-btn"
                onClick={handleApplyFilters}
                style={{ marginLeft: "5px", fontWeight: "600px" }}
              >
                Apply
              </button>
              <button
                onClick={onClosePopUp}
                className="cancel-btn"
                style={{ fontWeight: "600px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterTimeSheet;
